/**
 * Created by lk on 17/6/4.
 */
import axios from "axios";
import https from "../../utils/http";
import { getToken, getAdminId } from "../../utils/auth";
let http = https.https;

// 谁最懂我相关

// 列表
export function adList(query) {
    let querys = JSON.parse(JSON.stringify(query));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/ad/ad/index",
        method: "get",
        params: querys
    });
}

// 保存
export function adSave(data, formName, method = "post") {
    let querys = JSON.parse(JSON.stringify(data));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    var url = formName === "add" ? http + "/ad/ad/save" : http + "/ad/ad/edit";
    return axios({
        url: url,
        method: method,
        data: querys
    });
}

// 删除
export function adDelete(data) {
    let querys = JSON.parse(JSON.stringify(data));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/ad/ad/delete",
        method: "post",
        data: querys
    });
}
